import { useResizeObserver } from '@flex-design-system/fx-utils/hooks';
import { pipe } from '@fxts/core';
import { calc } from '@vanilla-extract/css-utils';
import { setElementVars } from '@vanilla-extract/dynamic';
import { useCallback, useEffect } from 'react';
import { segmentedControlIndicatorTranslateX, segmentedControlIndicatorHeight, segmentedControlIndicatorWidth } from '../components/indicator/indicator.vanilla.mjs';
import { segmentedControlPadding } from '../segmentedControl.vanilla.mjs';

function useSyncIndicatorToActiveItem(params) {
  const { indicatorElement, rootElement, value } = params;
  const syncIndicatorToActiveElement = useCallback(() => {
    if (indicatorElement === null || rootElement === null || !value) {
      return;
    }
    const activeElement = rootElement.querySelector(
      `[data-value="${CSS.escape(value)}"]`
    );
    if (activeElement === null) {
      return;
    }
    const rootElementWidth = pipe(
      window.getComputedStyle(rootElement),
      ({ width }) => pipe(Number.parseFloat(width), toPixel)
    );
    const { width: activeElementWidth, height: activeElementHeight } = pipe(
      window.getComputedStyle(activeElement),
      ({ width, height }) => ({
        width: pipe(Number.parseFloat(width), toPixel),
        height: pipe(Number.parseFloat(height), toPixel)
      })
    );
    setElementVars(indicatorElement, {
      [segmentedControlIndicatorWidth]: activeElementWidth,
      [segmentedControlIndicatorHeight]: activeElementHeight,
      [segmentedControlIndicatorTranslateX]: (
        // @prettier-ignore
        `clamp(${segmentedControlPadding},
               ${toPixel(activeElement.offsetLeft)},
               ${calc.subtract(rootElementWidth, activeElementWidth, segmentedControlPadding)})`
      )
    });
  }, [indicatorElement, rootElement, value]);
  useEffect(syncIndicatorToActiveElement, [syncIndicatorToActiveElement]);
  useResizeObserver(rootElement, syncIndicatorToActiveElement);
}
function toPixel(value) {
  return `${value}px`;
}

export { useSyncIndicatorToActiveItem };
//# sourceMappingURL=useSyncIndicatorToActiveItem.mjs.map
